"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      visible: false,
      details: {} // 预留一份数据
    };
  },
  methods: {
    openInit: function openInit(details) {
      this.details = details;
      this.visible = true;
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};